import { CurriculumCountryCodes } from '../constants/curriculum.const'
import { CurriculumGradeDataType, CurriculumTopicDataType } from '../types/curriculum.types'

export function useGetCurriculumSubjectContent(
  gradeContent: CurriculumGradeDataType,
  subjectOrder: string,
  countryCode: string,
): CurriculumTopicDataType {
  let subdivisionIndex = 0
  if (countryCode === CurriculumCountryCodes.PHILIPPINES || countryCode === CurriculumCountryCodes.USA) {
    subdivisionIndex = gradeContent.gradeSubdivisions.findIndex((subdivision) =>
      subdivision.subjects.some((subject) => subject.subjectOrder === Number(subjectOrder)),
    )
  }
  const subjectContent = gradeContent.gradeSubdivisions[subdivisionIndex]?.subjects.filter(
    (sub) => sub.subjectOrder.toString() === subjectOrder,
  )[0]
  return subjectContent
}
